// Wrap just the word "Details" in its own <span> inside the shipping/returns
// popup button, so CSS can underline only that word while the rest of the
// sentence stays plain — the whole button still opens the popup either way.
document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('ProductPopup-popup_XNXLpU');
  if (!btn) return;
  var text = btn.textContent.trim();
  var idx = text.lastIndexOf('Details');
  if (idx === -1) return;
  var before = text.slice(0, idx);
  var linkPart = text.slice(idx);
  btn.innerHTML = before + '<span class="popup-details-link">' + linkPart + '</span>';
});

// Footer menu accordion (mobile only): tapping a footer column heading
// (About, Help Center, Legal) toggles that column's links open/closed.
// The window-width check means desktop clicks do nothing, since the
// CSS above already keeps menus permanently expanded there anyway.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.footer-block--menu .footer-block__heading').forEach(function (heading) {
    heading.addEventListener('click', function () {
      if (window.innerWidth >= 750) return;
      heading.closest('.footer-block--menu').classList.toggle('is-open');
    });
  });
});

// Product Details and Size Guide both vary by the selected "Style" option.
// The Liquid renders every style's content already (hidden), so this just
// shows the one matching whichever Style button is currently selected —
// works regardless of how Dawn's variant picker updates the rest of the page.
document.addEventListener('change', function (event) {
  const fieldset = event.target.closest('fieldset');
  if (!fieldset) return;
  const legend = fieldset.querySelector('legend');
  if (!legend || !/style/i.test(legend.textContent)) return;

  const checked = fieldset.querySelector('input:checked');
  if (!checked) return;
  const selectedStyle = checked.value;

  document
    .querySelectorAll('.product-details-by-style__entry, .size-guide-by-style__entry')
    .forEach(function (entry) {
      entry.hidden = entry.dataset.style !== selectedStyle;
    });
});